import React, { memo } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const Button = memo(
  ({
    children,
    onClick,
    type = "button",
    className = "",
    disabled = false,
    variant = "",
    link = null,
  }) => {
    const base =
      "inline-flex items-center justify-center gap-2 px-4 py-2 rounded-xl font-semibold text-sm transition-all duration-200 active:scale-[0.97] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2";

    const variants = {
      primary:
        "bg-blue-500 text-white hover:bg-blue-600 shadow-sm hover:shadow-blue-500/30 hover:shadow-md focus-visible:ring-blue-500",
      secondary:
        "bg-[var(--surface)] text-[var(--text)] border border-[var(--border)] hover:bg-[var(--bg-secondary)] hover:border-[var(--border-hover)] shadow-sm focus-visible:ring-[var(--accent)]",
      danger:
        "bg-red-500 text-white hover:bg-red-600 shadow-sm hover:shadow-red-500/30 hover:shadow-md focus-visible:ring-red-500",
      success:
        "bg-emerald-500 text-white hover:bg-emerald-600 shadow-sm hover:shadow-emerald-500/30 hover:shadow-md focus-visible:ring-emerald-500",
    };

    const fallback =
      "border border-[var(--border)] text-[var(--text-muted)] hover:bg-[var(--surface)] hover:text-[var(--text)]";

    const disabledStyles = "opacity-50 cursor-not-allowed pointer-events-none";

    const finalClassName = [
      base,
      variants[variant] ?? fallback,
      disabled ? disabledStyles : "",
      className,
    ]
      .filter(Boolean)
      .join(" ");

    if (link) {
      return (
        <Link
          to={link}
          className={finalClassName}
        >
          {children}
        </Link>
      );
    }

    return (
      <button
        type={type}
        onClick={onClick}
        className={finalClassName}
        disabled={disabled}
      >
        {children}
      </button>
    );
  }
);

Button.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  variant: PropTypes.oneOf(["primary", "secondary", "danger", "success"]),
  link: PropTypes.string,
};

export default Button;
